import { Verification, VerificationNames } from "shared/types";

// Still need this because income verification title is
// Self-Reported and verified income verification it's Verified
export const mapCombinedVerificationNameToTitle = (
  verifications: Verification | Verification[]
) => {
  if (!Array.isArray(verifications)) {
    if (verifications.name === VerificationNames.SubmissionDisclosure)
      return "Disclosure";

    if (verifications.name == VerificationNames.CombinedIncome)
      return "Income history";

    if (verifications.name === VerificationNames.PetScreeningReport)
      return "Animal screening";

    if (
      verifications.name === VerificationNames.HousingHistory ||
      verifications.name === VerificationNames.PremiumHousingHistory
    )
      return "Housing history";

    return verifications.title;
  }

  if (verifications.some((v) => v.name.includes("income_verification")))
    return "Income report";

  return verifications[0].title;
};

export const mapCombinedVerificationToStatus = (
  verifications: Verification | Verification[],
  verificationName?: VerificationNames
) => {
  if (!Array.isArray(verifications)) return verifications.status;

  return (
    verifications.find((v) => v.name === verificationName)?.status ||
    verifications.map((v) => v.status).sort()[0]
  );
};
